import {
  OfferFragment,
  Payment_Instrument_Evaluation_Method,
  Payment_Instrument_Type,
  PaymentType,
} from '@occc/graphql';
import { makeCreatePaymentInstrumentConstraintOperation } from '@occc-app/offerHelpers/operations/constraints';
import { makeDeleteOperation } from '@occc-app/offerHelpers/operations/makeDeleteOperation';
import { Operation } from '@occc-app/offerHelpers/types';
import { constraintHelper } from '@occc-app/offerHelpers/utils/constraintHelper';

import { PaymentInstrumentOption } from './types';

import { PaymentMethodFormValues } from '../types';

export const getPaymentInstrumentConstraint = (offer: OfferFragment | null | undefined) => {
  return offer?.constraints.find(constraintHelper.isPaymentInstrument);
};

export const getPaymentInstrumentsInitialValues = (
  offer: OfferFragment | null | undefined,
): Payment_Instrument_Type[] => {
  const paymentMethodConstraint = getPaymentInstrumentConstraint(offer);
  return paymentMethodConstraint?.paymentInstruments || [];
};

export const getPaymentInstrumentConstraintOperations = (
  offerId: string,
  offer: OfferFragment | undefined,
  values: PaymentMethodFormValues | undefined,
): Operation[] => {
  const operations: Operation[] = [];
  const existingPaymentInstrumentConstraint = getPaymentInstrumentConstraint(offer);

  if (
    existingPaymentInstrumentConstraint &&
    existingPaymentInstrumentConstraint.paymentInstruments?.length > 0
  ) {
    operations.push(
      makeDeleteOperation('constraintDelete', existingPaymentInstrumentConstraint.id),
    );
  }

  if (
    values?.paymentMethodConstraint.isEnabled &&
    values?.paymentMethodConstraint.paymentInstruments &&
    values?.paymentMethodConstraint.paymentInstruments.length > 0
  ) {
    operations.push(
      makeCreatePaymentInstrumentConstraintOperation(
        offerId,
        Payment_Instrument_Evaluation_Method.Include,
        values.paymentMethodConstraint.paymentInstruments,
      ),
    );
  }

  return operations;
};

export const getSupportedPaymentInstruments = (
  supportedPaymentTypes: PaymentType[] | undefined,
): PaymentInstrumentOption[] => {
  if (!supportedPaymentTypes || supportedPaymentTypes.length === 0) {
    return [];
  }

  return supportedPaymentTypes.reduce<PaymentInstrumentOption[]>((acc, item) => {
    return item.type && item.title ? [...acc, { label: item.title, value: item.type }] : acc;
  }, []);
};
